import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useStateContext } from "../contexts/ContextProvider";
import Item from "../subComponent/Item";

const FeaturedProduct = () => {
  const {
    categories,
    CategoriesApiCall,
    singleCategoryDetails,
    setSingleCategoryDetails,
    setIsScrolled,
    singleCategory,
    sidebarOpened,
    cartItem,
    setItemDetail,
    products,
    setProducts,
    allProducts,
    setSidebarCartDetail,
  } = useStateContext();
  const [featuredProducts, setFeaturedProducts] = useState();

  useEffect(() => {
    // Scroll to the top of the page
    window.scrollTo(0, 0);

    // Reset single category details
    setProducts([]);

    // Make an API call to fetch categories
    allProducts();
    console.log("use effect called");
    // Fetch details for the single category based on the `id`
  }, []);

  useEffect(() => {
    if (products) {
      const filterObjectsByIndex = (objectsArray) => {
        return objectsArray.filter((obj, index) => index >= 263 && index <= 268);
      };
      setFeaturedProducts(filterObjectsByIndex(products));
    }
  }, [products]);

  return (
    <Component>
      {console.log(products)}
      <CategoriesWrapper>
        {/* Text Categories */}
        <TextCategories>
          <h1>FEATURED</h1>
        </TextCategories>

        {/* Category Cards */}
        <Category>
          <CardWrapper>
            {featuredProducts?.map((details, i) => (
              <Item key={details.categories_id + i} details={details} categ_id={details.categories_id} />
            ))}
          </CardWrapper>
        </Category>
      </CategoriesWrapper>
    </Component>
  );
};

export default FeaturedProduct;

const Component = styled.div`
  display: flex;
  min-height: 100vh;
  background: #f3e4e4;
  width: 100%;
  flex-direction: column;
`;

const CategoriesWrapper = styled.div`
  display: flex;
  flex-direction: row-reverse;
  min-height: 100vh;
  background: #f3e4e4;
  width: 100%;
`;

const Category = styled.div`
  width: 83%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10vh;
  @media (max-width: 1031px) {
    width: 100%;
    align-items: flex-start;
  }
`;

const TextCategories = styled.div`
  width: 17%;

  border-right: 2px solid pink;
  position: relative;
  @media (max-width: 1031px) {
    width: 0%;
    display: none;
  }
  h1 {
    position: absolute;
    opacity: 0.1;
    top: 17rem;
    left: -18%;
    font-size: 70px;
    transform: rotate(-90deg);
  }
`;

const CardWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 20px;

  @media (max-width: 800px) {
    gap: 10px;
  }
  @media (max-width: 660px) {
    gap: 8px;
  }
  @media (max-width: 430px) {
    gap: 8px;
    grid-template-columns: 1fr 1fr;
  }
`;
